import logo from "../assets/logo10years.png";

const Navbar = () => {
  return (
    <>
      <style>{`
        .navbar {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          z-index: 50;
          /* Matches bg-hero/90 with a fallback for transparency */
          background-color: hsla(220, 30%, 8%, 0.9); 
          backdrop-filter: blur(12px);
          -webkit-backdrop-filter: blur(12px);
          border-bottom: 1px solid rgba(255, 255, 255, 0.1);
        }

        .nav-container {
          max-width: 1200px;
          margin: 0 auto;
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 0.75rem 1rem;
        }

        .nav-logo {
          height: 2rem; /* h-8 */
          display: block;
        }

        .nav-button {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          border-radius: 0.5rem;
          background-color: hsl(171, 76%, 40%); /* Your secondary/primary brand color */
          color: white;
          font-weight: 600;
          font-size: 0.875rem;
          text-decoration: none;
          padding: 0.625rem 1.25rem;
          transition: background-color 0.2s, transform 0.2s;
          box-shadow: 0 10px 15px -3px rgba(45, 212, 191, 0.2);
        }

        .nav-button:hover {
          background-color: hsl(171, 76%, 35%);
          transform: translateY(-1px);
        }

        .nav-button:active {
          transform: translateY(0);
        }

        /* Responsive height for logo */
        @media (min-width: 768px) {
          .nav-logo {
            height: 2.5rem; /* md:h-10 */
          }
          .nav-container {
            padding: 0.75rem 1.5rem;
          }
        }
      `}</style>

      <nav className="navbar">
        <div className="nav-container">
          <img src={logo} alt="The Startup Zone" className="nav-logo" />
          <a href="#get-ebook" className="nav-button">
            Get the Free Ebook
          </a>
        </div>
      </nav>
    </>
  );
};

export default Navbar;